// extracted by mini-css-extract-plugin
module.exports = {"root":"WithModuleText_root__EsADk","textTitle":"WithModuleText_textTitle__WDamV","buttonsWrapper":"WithModuleText_buttonsWrapper__vSrT3","modal":"WithModuleText_modal__m3cuk"};